"use strict";

import parameterServices from "dias/foerderregeln/parameter/services";
import template from "dias/foerderregeln/parameter/json/config.jade";
import templateRo from "dias/foerderregeln/parameter/json/readonly.jade";
import controller from "dias/foerderregeln/parameter/json/controller";


const signalKosten = angular.module("dias.kosten_finanzierung.modul.signal_kosten.parameter", [
  parameterServices.name,
])

  .config(function(ParametermoduleRegistryProvider) {
    ParametermoduleRegistryProvider.register("signal_kosten_regeldata", "parametermodul-signal-kosten-regeldata");
  })
  .component("parametermodulSignalKostenRegeldata", {
    bindings: {
      parameter: "=",
      key: "@",
      controlId: "@?",
    },
    template: template(),
    controller: controller,
    controllerAs: "vm",
  })
  .component("parametermodulSignalKostenRegeldataRo", {
    bindings: {
      parameter: "=",
      key: "@"
    },
    template: templateRo(),
    controller: controller,
    controllerAs: "vm",
  })
;
export default signalKosten;
